import { render } from "./Firebase.vue?vue&type=template&id=5ebd868a&scoped=true"
import script from "./Firebase.vue?vue&type=script&lang=js"
export * from "./Firebase.vue?vue&type=script&lang=js"

import "./Firebase.vue?vue&type=style&index=0&id=5ebd868a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebd868a"]])

export default __exports__